export var AppStateEntities;
(function (AppStateEntities) {
    AppStateEntities["User"] = "user";
    AppStateEntities["Account"] = "account";
    AppStateEntities["UserAccount"] = "user-account";
})(AppStateEntities || (AppStateEntities = {}));
//# sourceMappingURL=app-state.enum.js.map